import * as HttpService from "../../../../service/HttpService";


/** 运行监控  -> 实时监控服务 **/

/**
 *  获取实时信息
 */
export const getRealTimeData = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/realTimeMonitoring/getDeviceInfo", params);
}

/**
 * 保存设置信息
 * @param params  superiorid: 组织树id  rightContainer: 右侧集合信息
 * @returns {Promise<Response>}
 */
export const saveSetting = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/realTimeMonitoring/saveRadio", params);
}

/**
 * 获取历史曲线
 */
export const getHistoryCurve = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/realTimeMonitoring/getHistoricalCurve", params);
}
